import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Skull, Dices, X } from "lucide-react";
import { BROKEN_TABLE, rollBroken } from "@/lib/character";

export default function BrokenPrompt({ open, onClose, onResult }) {
  const [result, setResult] = useState(null);
  const [rolling, setRolling] = useState(false);

  useEffect(() => {
    if (!open) { setResult(null); setRolling(false); }
  }, [open]);

  const roll = () => {
    setRolling(true);
    setTimeout(() => {
      const r = rollBroken();
      setResult(r);
      setRolling(false);
      if (onResult) onResult(r);
    }, 500);
  };

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[90] flex items-center justify-center p-4" data-testid="broken-modal">
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/85 backdrop-blur-sm"
            onClick={onClose}
          />
          <motion.div
            initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 20, opacity: 0 }}
            transition={{ type: "spring", damping: 22 }}
            className="relative panel panel-magenta p-6 w-full max-w-lg"
          >
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-3">
                <Skull className="text-[color:var(--accent-magenta)]" />
                <div className="font-display uppercase font-black tracking-tight text-2xl">YOU ARE BROKEN</div>
              </div>
              <button data-testid="broken-close" onClick={onClose} aria-label="Close" className="p-1 hover:text-[color:var(--accent-yellow)]">
                <X size={18} />
              </button>
            </div>
            <div className="font-mono text-xs text-[color:var(--text-secondary)] uppercase tracking-widest mb-4">
              HP hit zero. Roll a d8 on the Broken table.
            </div>

            {!result ? (
              <button data-testid="broken-roll-btn" onClick={roll} className="cy-btn cy-btn-solid-yellow w-full" disabled={rolling}>
                <Dices size={16} className={`mr-2 ${rolling ? "dice-rolling" : ""}`} /> {rolling ? "ROLLING…" : "ROLL d8"}
              </button>
            ) : (
              <div className="border-2 border-[color:var(--accent-yellow)] p-4" data-testid="broken-result">
                <div className="text-[10px] font-mono uppercase tracking-widest text-[color:var(--text-muted)]">
                  d8 → <span className="text-[color:var(--accent-yellow)] font-black">{result.roll}</span>
                </div>
                <div className="font-display uppercase font-black text-xl mt-1 leading-tight text-[color:var(--text-primary)]">
                  {result.effect}
                </div>
              </div>
            )}

            <div className="mt-4 max-h-[240px] overflow-y-auto border-2 border-dashed border-[color:var(--border-hard)] p-3">
              <div className="text-[10px] font-mono uppercase tracking-widest text-[color:var(--text-muted)] mb-2">BROKEN TABLE — d8</div>
              {BROKEN_TABLE.map((e) => (
                <div key={e.roll} className={`text-xs font-mono mb-1 ${result?.roll === e.roll ? "text-[color:var(--accent-yellow)]" : "text-[color:var(--text-secondary)]"}`}>
                  <span className="inline-block w-4 font-bold">{e.roll}</span> · {e.effect}
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
